import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IReplyValuesDataTableRowFormMeta {
    // Condition Group Table modal form fields
    resp: FormInputMeta;
    tick: FormInputMeta;
    diary: FormInputMeta;
    cash: FormInputMeta;
    seq: FormInputMeta;
    
    // Result Group Table modal form fields
    type: FormInputMeta;
    stateNum: FormInputMeta;
    screenNum: FormInputMeta;
    func: FormInputMeta;
    receipt: FormInputMeta;
    diary2: FormInputMeta;
    
    schema: any;
}
const replyValuesDataTableRowFormMeta = {} as IReplyValuesDataTableRowFormMeta;
  
// Condition Group table modal form fields
replyValuesDataTableRowFormMeta.resp = {
    name: "resp",
    type: "text",
    label: "Resp.",
    placeholder: "",
    validation: yup.string(),
};

replyValuesDataTableRowFormMeta.tick = {
    name: "tick",
    type: "text",
    label: "Tick",
    placeholder: "",
    validation: yup.string(),
};

replyValuesDataTableRowFormMeta.diary = {
    name: "diary",
    type: "text",
    label: "Journal",
    placeholder: "",
    validation: yup.string(),
};

replyValuesDataTableRowFormMeta.cash = {
    name: "cash",
    type: "text",
    label: "Cash",
    placeholder: "",
    validation: yup.string(),
};

replyValuesDataTableRowFormMeta.seq = {
    name: "seq",
    type: "text",
    label: "Seq.",
    placeholder: "",
    validation: yup.string(),
};


// Result Group table modal form fields
replyValuesDataTableRowFormMeta.type = {
    name: "type",
    type: "checkbox",
    label: "Type",
    placeholder: "",
    validation: yup.boolean(),
};

replyValuesDataTableRowFormMeta.stateNum = {
    name: "stateNum",
    type: "select",
    label: "State Num.",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire"),
};
  
replyValuesDataTableRowFormMeta.screenNum = {
    name: "screenNum",
    type: "select",
    label: "Screen Num.",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire"),
};
  
replyValuesDataTableRowFormMeta.func = {
    name: "func",
    type: "select",
    label: "Func.",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire"),
};
  
replyValuesDataTableRowFormMeta.receipt = {
    name: "receipt",
    type: "select",
    label: "Receipt",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire"),
};
  
replyValuesDataTableRowFormMeta.diary2 = {
    name: "diary2",
    type: "select",
    label: "Journal",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire"),
};
  

replyValuesDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(replyValuesDataTableRowFormMeta));

export default replyValuesDataTableRowFormMeta;